export default __webpack_public_path__ + "static/media/orderbackground2.842fdb4d.png";